<template>
  <div class="flow">
    <div class="aside">
      <div class="title">
        <i class="icon icon-sys"></i>
        <span>{{ isEdit ? $t('dms_protocol_item.bian_ji_xie_yi') : $t('dms_protocol_item.xin_zeng_xie_yi') }}</span>
      </div>
      <t-step v-model="step" :list="stepList" @step="onStepChange"></t-step>

      <div class="product-sn" v-if="protocolCode">{{ protocolCode }}</div>
    </div>
    <!-- 内容区域 -->
    <div class="section">
      <item-base v-if="step === 1" @step="onStep" :info="info" @cancel="onCancel"></item-base>
      <item-construct v-if="step === 2" @step="onStep" :info="info" @back="onBack" @cancel="onCancel"></item-construct>
      <item-model v-if="step === 3" @step="onStep" :info="info" @back="onBack" @cancel="onCancel"></item-model>
      <item-topic v-if="step === 4" @step="onStep" :info="info" @back="onBack" @cancel="onCancel"></item-topic>
      <item-rule v-if="step === 5" @step="onStep" :protocolId="protocolId" :protocolType="protocolType" @back="onBack" @cancel="onCancel"></item-rule>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tStep from '@/components/step.vue';
import itemBase from './children/protocol_item_base.vue';
import itemConstruct from './children/protocol_item_construct.vue';
import itemModel from './children/protocol_item_model.vue';
import itemTopic from './children/protocol_item_topic.vue';
import itemRule from './children/protocol_item_rule.vue';

export default {
  name: 'protocol_item',
  components: {
    tStep,
    itemBase,
    itemConstruct,
    itemModel,
    itemTopic,
    itemRule,
  },
  data() {
    return {
      productId: '',
      productCode: '',
      protocolId: '',
      protocolCode: '',
      protocolType: '',

      type: '',

      step: 1,
      info: {},
    };
  },
  computed: {
    isEdit() {
      const path = this.$route.path;
      return path.includes('/edit');
    },
    stepList() {
      const list = [
        {
          label: 1,
          value: 1,
          title: this.$t('dms_protocol_item.xie_yi_xin_xi'),
          subTitle: this.$t('dms_protocol_item.jbxxbj'),
        },
        {
          label: 2,
          value: 2,
          title: this.$t('dms_protocol_item.xie_yi_jie_gou'),
          subTitle: this.$t('dms_protocol_item.xyjggl'),
        },
        {
          label: 3,
          value: 3,
          title: this.$t('dms_protocol_item.wu_mo_xing'),
          subTitle: this.$t('dms_protocol_item.wu_mo_xing_guan_li'),
        },
        {
          label: 4,
          value: 4,
          title: 'Topic',
          subTitle: this.$t('dms_protocol_item.Topicguan_li'),
        },
        // {
        //   label: 5,
        //   value: 5,
        //   title: '协议规则',
        //   subTitle: '规则管理'
        // },
      ];
      return list;
    },
  },
  mounted: function () {
    this.init();

  },
  methods: {
    init() {
      const query = this.$route.query;
      const protocolType = query.protocolType;
      this.protocolCode = query.protocolCode;
      if (this.isEdit) {
        this.getInfo();
      } else {
        this.info = {
          protocolType,
        };
      }
    },
    getInfo() {
      this.$getJSON(`${apis.protocolInfo}/${this.protocolCode}`).then((res) => {
        this.info = res.data;
      });
    },

    onStepChange(step) {
      if (this.isEdit) {
        this.step = step;
      }
    },
    // 取消
    onCancel: function () {
      this.clearTagByKeep('protocol_item');
      this.jump('/iot/protocol', {}, true);
    },
    // 上一步
    onBack: function () {
      this.step--;
    },
    // 下一步
    onStep: function (val) {
      if (val) {
        if (val.info) {
          this.info = val.info;
        }
      }
      this.step++;
      this.clearKeepAlive('protocol');
    },
    onUpdate: function (val) {
      this.info = val;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.flow {
  .product-sn {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #eef2f8;
    font-size: 14px;
    color: #495057;
    z-index: 100;
  }
}
</style>
